import { ControlledInput } from "components/Card/ControlledInput";
import { TextInput } from "components/inputs";
import type { Control } from "react-hook-form";

import type { OrganizationSettingsFormValues } from "./SettingsPage";

type AcknowledgementLetterContactsSectionProps = {
  control: Control<OrganizationSettingsFormValues>;
  handleFieldChange: (
    field: keyof OrganizationSettingsFormValues,
    value: string,
  ) => Promise<void>;
};

const AcknowledgementLetterContactsSection = ({
  control,
  handleFieldChange,
}: AcknowledgementLetterContactsSectionProps) => {
  return (
    <>
      <div className="header-primary flex jc-sb ai-c">
        <div className="text-sm text-gray-500">
          MSA Acknowledgement Letter Contact
        </div>
      </div>

      <ControlledInput
        control={control}
        name="msa_acknowledgement_contact_title"
        label="Title"
        errors={{}}
        onSave={(value) =>
          handleFieldChange("msa_acknowledgement_contact_title", String(value))
        }
        componentType={TextInput}
        maxLength={100}
      />

      <ControlledInput
        control={control}
        name="msa_acknowledgement_contact_name"
        label="Name"
        errors={{}}
        onSave={(value) =>
          handleFieldChange("msa_acknowledgement_contact_name", String(value))
        }
        componentType={TextInput}
        maxLength={255}
      />

      <ControlledInput
        control={control}
        name="msa_acknowledgement_contact_phone"
        label="Phone"
        errors={{}}
        onSave={(value) =>
          handleFieldChange("msa_acknowledgement_contact_phone", String(value))
        }
        componentType={TextInput}
        maxLength={50}
      />

      <div className="header-primary flex jc-sb ai-c">
        <div className="text-sm text-gray-500">
          MCP Acknowledgement Letter Contact
        </div>
      </div>

      <ControlledInput
        control={control}
        name="mcp_acknowledgement_contact_title"
        label="Title"
        errors={{}}
        onSave={(value) =>
          handleFieldChange("mcp_acknowledgement_contact_title", String(value))
        }
        componentType={TextInput}
        maxLength={100}
      />

      <ControlledInput
        control={control}
        name="mcp_acknowledgement_contact_name"
        label="Name"
        errors={{}}
        onSave={(value) =>
          handleFieldChange("mcp_acknowledgement_contact_name", String(value))
        }
        componentType={TextInput}
        maxLength={255}
      />

      <ControlledInput
        control={control}
        name="mcp_acknowledgement_contact_phone"
        label="Phone"
        errors={{}}
        onSave={(value) =>
          handleFieldChange("mcp_acknowledgement_contact_phone", String(value))
        }
        componentType={TextInput}
        maxLength={50}
      />
    </>
  );
};

export default AcknowledgementLetterContactsSection;
